module.exports = __webpack_public_path__ + "img/tent_mountain.c80310bf.jpg";